module.exports = __webpack_public_path__ + "static/media/weather_sunset.cf01f54e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/weather-icons/weather_sunset.svg
// module id = 537
// module chunks = 0